import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { WorkitemActivityIndicatorModule } from 'shared/components/workitem-activity-indicator/workitem-activity-indicator.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { WorkItemTextChatListWrapperComponent } from './workitem-text-chat-list-wrapper.component';
import { WorkItemTextChatListContentComponent } from './workitem-text-chat-list-content/workitem-text-chat-list-content.component';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { WorkItemInteractionModule } from '../shared/workitem-interaction/work-item-interaction.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    SvgAvatarModule,
    WorkitemActivityIndicatorModule,
    TranslateModule.forChild(),
    TooltipModule,
    CustomPipesModule,
    WorkItemInteractionModule
  ],
  declarations: [
    WorkItemTextChatListWrapperComponent,
    WorkItemTextChatListContentComponent
  ],
  exports: [
    WorkItemTextChatListWrapperComponent
  ]
})
export class WorkItemTextChatListModule {}
